import type { PremiumTier } from '@root/entities/premium/model/premium-tier'

export type TierRank = 'gold' | 'platinum' | 'diamond' | 'elite'

const premiumTierToTierRankMap: Record<PremiumTier, TierRank> = {
  'gold-1': 'gold',
  'gold-2': 'gold',
  'gold-3': 'gold',
  'platinum-1': 'platinum',
  'platinum-2': 'platinum',
  'platinum-3': 'platinum',
  'diamond-1': 'diamond',
  'diamond-2': 'diamond',
  'diamond-3': 'diamond',
  elite: 'elite',
}

export const fromPremiumTier = (tier: PremiumTier): TierRank => {
  return premiumTierToTierRankMap[tier]
}
